import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'core/store';

const activeCycleReducer = (state: RootState) => state.private.activeCycle;

export const activeCycleOptionsSelector = createSelector(
  activeCycleReducer,
  (activeCycle) => activeCycle.activeCycleOptions
);
export const activeOrdersSfSelector = createSelector(activeCycleReducer, (activeCycle) => activeCycle.activeOrdersSf);
export const activeOrderSfDetailSelector = createSelector(
  activeCycleReducer,
  (activeCycle) => activeCycle.activeOrderSfDetail
);
export const activeCycleOrdersAttiviSelector = createSelector(
  activeCycleReducer,
  (activeCycle) => activeCycle.activeCycleOrdersAttivi
);
export const activeCycleProjectsAssociatedSelector = createSelector(
  activeCycleReducer,
  (activeCycle) => activeCycle.activeCycleOrdersAttivi?.[0]?.associatedProjectActiveOrder || []
);
export const activeCycleProjectsAssociatedForBillsSelector = createSelector(
  activeCycleReducer,
  (activeCycle) => activeCycle.activeCycleOrdersAttiviForBills || []
);
export const activeCycleFattureEmesseSelector = createSelector(
  activeCycleReducer,
  (activeCycle) => activeCycle.activeCycleFattureEmesse
);
export const associableProjectsActiveCycleSelector = createSelector(
  activeCycleReducer,
  (activeCycle) => activeCycle.associableProjects
);
export const associableInvoicesActiveCycleSelector = createSelector(
  activeCycleReducer,
  (activeCycle) => activeCycle.associableInvoices
);
export const filtersOrdersSfUsedSelector = createSelector(
  activeCycleReducer,
  (activeCycle) => activeCycle.filtersOrdersSfUsed
);
export const filtersActiveAssociableInvoicesUsedSelector = createSelector(
  activeCycleReducer,
  (activeCycle) => activeCycle.filtersActiveAssociableInvoicesUsed
);
export const associableInvoicesPagingSelector = createSelector(
  activeCycleReducer,
  (activeCycle) => activeCycle.associableInvoicesPaging
);
